// TRIL-420: pure gate-reason helpers extracted from PostDraft and PostReplyDraft
// so both components share the same logic and the tests guard the real function.
import { charCounter } from '../constants/post.constants';

// The floor is "unknown" whenever min === null — whether the query is still
// loading OR it failed. We gate on that (not on `loading`), so a background
// revalidation that already has a cached floor never re-blocks publish. When the
// floor is unknown, `constraintsError` picks the message: an honest error (+ the
// component renders a retry) vs. the transient "checking".
export function postPublishDisabledReason(
  isAnalyzing: boolean,
  constraintsError: boolean,
  min: number | null,
  storyLength: number,
  categoriesExist: boolean,
  reAnalyzeStory: boolean,
  hasStoryAnalysis: boolean,
): string | null {
  const belowMinLength = min !== null && storyLength < min;
  return isAnalyzing
    ? null
    : min === null
      ? constraintsError
        ? charCounter.loadError
        : charCounter.checking
      : belowMinLength
        ? `Posts must be at least ${min} characters to publish (currently ${storyLength}).`
        : !categoriesExist
          ? 'Add at least one category to publish.'
          : reAnalyzeStory
            ? 'Re-analyze your edited story to publish.'
            : !hasStoryAnalysis
              ? 'Analyze your story to publish.'
              : null;
}

export function replyPublishDisabledReason(
  isAnalyzing: boolean,
  constraintsError: boolean,
  min: number | null,
  replyLength: number,
  hasStoryAnalysis: boolean,
): string | null {
  const belowMinLength = min !== null && replyLength < min;
  return isAnalyzing
    ? null
    : min === null
      ? constraintsError
        ? charCounter.loadError
        : charCounter.checking
      : belowMinLength
        ? `Replies must be at least ${min} characters to publish (currently ${replyLength}).`
        : !hasStoryAnalysis
          ? 'Analyze your reply to publish.'
          : null;
}
